// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".code-submit-button[data-v-78960e82]{font-size:1.5em}", "",{"version":3,"sources":["webpack://./resources/js/components/trainings/ProviderTrainingKnowledgeQuiz.vue"],"names":[],"mappings":"AACI,qCACI,eAAR","sourcesContent":["\n    .code-submit-button {\n        font-size: 1.5em;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
